import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { applicationTypeLabels } from "@common/types/closeApplicationType";

interface Props {
    filters: FiltersTypes;
}

export const ApplicationTypeFilterLabel: React.FC<Props> = ({ filters }) => {
    const { applicationTypes } = filters;

    if (!applicationTypes || applicationTypes.length === 0) {
        return null;
    }

    const labels = applicationTypes.map((t) => applicationTypeLabels[t]);

    if (labels.length === 1) {
        return <span>{labels[0]}</span>;
    }

    return <span>{labels.length} application types</span>;
};
